
import kladrUtils from 'kladr-utils';

import {
	unwrap,
} from './util';

import vb from './definition';

vb.kladrSettlementInRegion = (optionAccessors) => {
	return {
		validator: k => {
			if (!k) {
				return true;
			}

			const region = unwrap(optionAccessors.region);

			if (!region) {
				return true;
			}

			return kladrUtils.contains(region, k);
		},
		message: [
			'выберите населённый пункт из соответствующего региона',
			'не соответствует региону',
		],
	};
};

vb.kladrSettlementNameInRegion = (optionAccessors) => {
	return {
		validator: v => {
			if (!v) {
				return true;
			}

			const k = optionAccessors.dictionary.get(v);

			if (!k) {
				return true;
			}

			const region = unwrap(optionAccessors.region);

			if (!region) {
				return true;
			}

			return kladrUtils.contains(region, k);
		},
		message: [
			'выберите населённый пункт из соответствующего региона',
			'не соответствует региону',
		],
	};
};
